import { useEffect, useMemo, useRef } from "react";
import debounce from "lodash/debounce";
/**
 * Calls debounce from lodash internally.
 *
 * Different from useDebounce in that the function is immediately available to call and doesn't wait for the next effect phase
 **/
export function useDebounceSync(
/** the function to apply debouncing to. Use in combination with useCallback if the function is defined inline */
cb, delay) {
    const ref = useRef(); // type cast because ref.current is guaranteed to be assigned to cb and cb is a function
    useMemo(() => {
        ref.current?.cancel();
        ref.current =
            process.env.NODE_ENV === "test"
                ? Object.assign(cb, { cancel() { } })
                : debounce(cb, delay);
    }, [cb, delay]);
    // clean up on unmount
    useEffect(() => () => ref.current?.cancel(), []);
    return ref.current;
}
